export default "__VITE_ASSET__c8b5d8ed__"